import { getOperation } from "utils/api";
import {
  createOptionsCacheHook,
  resolveHasMoreOptions,
} from "./globalOptionsCache";

const PAGE_SIZE = 500;
const CACHE_NAMESPACE = "merchant-options";

const buildMerchantOption = (merchant) => {
  const merchantId = `${merchant?.merchantId ?? ""}`.trim();
  const name = `${merchant?.name ?? ""}`.trim();

  if (!merchantId) return null;

  return {
    key: merchantId,
    title: name ? `${merchantId} - ${name}` : merchantId,
    value: merchantId,
    payfacPrefix: merchant?.payfacPrefix ?? "",
  };
};

const fetchMerchantOptionsFromApi = async (params) => {
  try {
    const requestParams = {
      page: 0,
      size: PAGE_SIZE,
      ...(params.keyword ? { keyword: params.keyword } : {}),
      ...(params.payfacPrefix ? { payfacPrefix: params.payfacPrefix } : {}),
      ...(params.isoAgentId ? { isoAgentId: params.isoAgentId } : {}),
    };

    const apiResponse = await getOperation("/merchant/options", {
      ...requestParams,
    });

    const responseBody = apiResponse?.data;
    if (!responseBody || responseBody.responseCode !== "0000") {
      return { options: [], hasMoreOptions: false };
    }

    const options = responseBody.data?.map(buildMerchantOption).filter(Boolean) || [];

    return {
      options,
      hasMoreOptions: resolveHasMoreOptions(
        responseBody?.total,
        options.length,
        PAGE_SIZE,
      ),
    };
  } catch (error) {
    return { options: [], hasMoreOptions: false };
  }
};

export const useMerchantOptionsCache = createOptionsCacheHook({
  namespace: CACHE_NAMESPACE,
  buildCacheKey: (params = {}) => JSON.stringify(params),
  fetcher: (params = {}) => fetchMerchantOptionsFromApi(params),
  fetchProperty: "fetchMerchantOptions",
  invalidateProperty: "invalidateMerchantOptionsCache",
});
